<template>
  <v-window-item value="overview">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="7">
          <v-card variant="outlined">
            <v-card-title class="text-subtitle-1">Target Information</v-card-title>
            <v-card-text>

              <v-row dense>
                  <v-col v-for="field in targetFields" :key="field.title" cols="12" sm="6">
                    <v-list-item class="bg-grey-lighten-4" >
                      <template #title>
                        <span class="text-subtitle-2 text-grey-darken-1">{{ field.title }}</span>
                        <p class="text-subtitle-2 " style="color: black; background:transparent;">{{ field.value }}</p>
                      </template>
                    </v-list-item>
                  </v-col>
                </v-row>

            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="5">
          <v-card variant="outlined">
            <v-card-title class="text-subtitle-1">Progress</v-card-title>
            <v-card-text>
              <v-card class="pa-3 d-flex justify-space-between d-flex bg-white" color="grey-lighten-4" flat>
                <v-pie
                    title="Quantity Achievement"
                    :items="quantityAchievementPie"
                    :legend="{ textFormat: '[title] ([value]%)' }"
                    :tooltip="{ subtitleFormat: '[value]%' }"
                    gap="4"
                    inner-cut="70"
                    :size="140"
                    animation
                    legend
                    :palette="['#2A7C13', '#E0E0E0']"
                />
                <v-pie
                    title="Amount Achievement"
                    :items="amountAchievementPie"
                    :legend="{ textFormat: '[title] ([value]%)' }"
                    :tooltip="{ subtitleFormat: '[value]%' }"
                    gap="4"
                    inner-cut="70"
                    :size="140"
                    animation
                    legend
                    :palette="['#932F67', '#E0E0E0']"
                />
              </v-card>

              <v-card color="grey-lighten-4" flat class="pa-4 mt-3">
                <div class="d-flex justify-space-between text-body-2">
                  <span>Current Position</span>
                  <v-chip size="small" color="warning">{{ progressData.currentPosition }}</v-chip>
                </div>

                <div class="d-flex justify-space-between text-body-2 mt-1">
                  <span>Remaining Months</span>
                  <strong>{{ progressData.remainingMonths }}</strong>
                </div>

                <div class="d-flex justify-space-between text-body-2 mt-1">
                  <span>Required Run Rate</span>
                  <strong>{{ progressData.requiredRunRate }}</strong>
                </div>
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-window-item>
</template>

<script>
export default {
  props: {
    targetData: {
      type: Object,
      default: () => ({}),
    },
    progressData: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    quantityAchievementPie(){
      return [
        {
          key: 1,
          title: `Achieved `,
          value: Number((this.progressData.quantityAchievement).toFixed(2)),
        },
        {
          key: 2,
          title: `Remaining`,
          value: Number((100-this.progressData.quantityAchievement).toFixed(2)),
        },
      ]
    } ,
    amountAchievementPie(){
      return [
        {
          key: 1,
          title: `Achieved `,
          value: Number((this.progressData.amountAchievement).toFixed(2)),
        },
        {
          key: 2,
          title: `Remaining`,
          value: Number((100-this.progressData.amountAchievement).toFixed(2)),
        },
      ]
    } ,
    targetFields() {
      return [
        { title: "Target Owner", value: this.targetData.employee?.name || "-" },
        { title: "Employee Code", value: this.targetData.employee?.code || "-" },
        { title: "Department", value: this.targetData.department || "-" },
        { title: "Team", value: this.targetData.team || "-" },
        { title: "Target Year", value: this.targetData.year || "-" },
        { title: "Target Type", value: this.targetData.targetType || "-" },
        { title: "Period", value: this.targetData.period || "-" },
        { title: "Remarks", value: this.targetData.remarks || "-" },
      ];
    },
  },
};
</script>

<style scoped>
:deep(.v-pie__legend__text, .v-chip__prepend) {
  font-size: 10px !important;
}
</style>
